<template>
    <div v-if="completed">
        <div id="navigationPlaceholder" style="padding-top: 60px;">
            <Navigation></Navigation>
        </div>

        <div class="container-flex m-5">
            <img :src="logoUrl" alt="Logo" class="mr-2 rounded-circle" style="max-height: 100px;" />

            <div v-for="(c, index) in categories" :key="c.id" class="p-2">
                <div class="fg-color-gray d-flex justify-content-between align-items-center p-1 mb-2" style="white-space: nowrap;">
                    <hr class="m-0" style="width: 100%;" />
                    <span>&nbsp;&nbsp;</span>
                    <h5 class="text-right mb-0">
                        <i v-if="c.CategoryIcon" class="fa" :class="[`fa-${c.CategoryIcon}`]" aria-hidden="true"></i>
                        {{c.Title}}
                    </h5>
                </div>

                <div class="row">
                    <div v-for="s in c.Items" :key="s.id" class="col-sm-6 col-lg-4 mb-4">
                        <div class="card" style="box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);">
                            <div class="card-body" style="background-color: #f4f4f4;">
                                <h5 class="fg-color-blue card-title text-ellipsis" :title="s.Title">{{s.Title}}</h5>
                                <ul class="list-unstyled w-100" style="height: 150px; overflow-x: hidden; overflow-y: auto;">
                                    <li v-for="i in s.Items" :key="i.id" class="mb-2 highlight-on-hover">
                                        <a :href="i.Url" :target="i.OpenInNewWindow ? '_blank' : '_self'" :title="i.Title"
                                           class="d-flex justify-content-between align-items-center card-link fg-color-gray"
                                           style="border-bottom: 1px dotted lightgray; padding-bottom: 3px;">
                                            
                                            <span class="text-ellipsis" style="max-width: 70%; overflow: hidden; white-space: nowrap;" 
                                                  v-html="i.Title"></span>
                                            
                                            <span v-if="i.DueDateText" title="Due date"
                                                  :class="['due-date-badge', i.DueDateClass]"
                                                  style="white-space:nowrap; font-size:0.95em;">
                                                {{ i.DueDateText }}
                                            </span>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <br />
        <br />
    </div>
</template>

<script lang="ts" setup>
    import { ref, computed, onMounted, watch } from 'vue'
    import { useRoute } from '@common/composables'
    import { useDashboardPage } from '@Organizations/Users/pages-core'
    import Navigation from '@common/Navigation.vue';

    const { useUserDashboardQuery } = useDashboardPage()
    const { modelUserDashboardQueryV1, runUserDashboardQueryV1, authorized, completed } = useUserDashboardQuery()
    const categories = computed(() => modelUserDashboardQueryV1.value?.Categories || [])
    const logoUrl = computed(() => modelUserDashboardQueryV1.value?.LogoUrl)

    document.title = "TransparentChoice Dashboard"

    onMounted(() => runUserDashboardQueryV1())

    watch(authorized, () => {
        if (authorized.value === false) {
            location.href = '/#/signin';
        }
    })
</script>

<style scoped>
    .highlight-on-hover:hover {
        font-weight: bold;
        transition: border-bottom 0.3s;
    }

    .due-date-badge {
        padding: 2px 10px;
        border-radius: 12px;
        background: #f1f1f1;
        margin-left: 8px;
        display: inline-block;
        border: 1px solid #cccccc;
    }

    .due-date-overdue {
        background: #faeaea;
        color: #c82333;
        border: 1px solid #c82333;
    }

    .due-date-soon {
        background: #fff4e5;
        color: #fd7e14;
        border: 1px solid #fd7e14;
    }
    
</style>